import Select from "./InputSelect.js";
import SelectLangue from "./InputSelectLanguage.js";
import InputLoupe from "./InputIcone.js";
import InputSimple from "./Input";
import InputNumber from "./InputNumber";
import InputInaccessible from "./InputInaccessible";

export { Select, SelectLangue, InputLoupe, InputSimple, InputNumber, InputInaccessible };
